import apiReminderBuilder from "../../../api";
import apiReminderSource from "../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

// Dropdown data of the source editor: the models a source can start from and the module list.
export const loadSourceDependencies = async () => {
  const [modelsRes, moduleKeysRes] = await Promise.allSettled([
    apiReminderSource.getModels(),
    apiReminderBuilder.getModuleKeys(),
  ]);

  return {
    models: extract(modelsRes),
    moduleKeys: extract(moduleKeysRes),
  };
};

// Dropdown data of the list's advanced filter.
export const loadSourceFilterDependencies = async () => {
  const [moduleKeysRes] = await Promise.allSettled([apiReminderBuilder.getModuleKeys()]);
  return { moduleKeys: extract(moduleKeysRes) };
};
